import { Injectable } from '@angular/core';
import { ApolloLink } from '@apollo/client/core';
import { JwtService } from '../services/jwt.service';

export function createTokenAfterware(jwtService: JwtService): ApolloLink {
    return new ApolloLink((operation, forward) => {
        return forward(operation).map(response => {
            // Check if the response contains a token
            // This depends on your API response structure
            if (response.data?.['login']?.token) {
                jwtService.saveToken(response.data['login'].token);
            }

            // You can add more conditions for other operations that might return tokens
            if (response.data?.['refreshToken']?.token) {
                jwtService.saveToken(response.data['refreshToken'].token);
            }

            return response;
        });
    });
}